// 권한 체크 유틸리티 함수들

/**
 * 사용자의 권한 레벨을 확인하는 함수
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {number} admin_level (1: Super Admin, 2: Operator, 3: Read-only)
 */
export const getUserAdminLevel = (myAdmin) => {
  return myAdmin?.admin_level || 3; // 기본값은 Read-only
};

/**
 * Super Admin 권한 확인
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {boolean}
 */
export const isSuperAdmin = (myAdmin) => {
  return getUserAdminLevel(myAdmin) === 1;
};

/**
 * Operator 이상 권한 확인 (Super Admin + Operator)
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {boolean}
 */
export const isOperatorOrAbove = (myAdmin) => {
  const level = getUserAdminLevel(myAdmin);
  return level === 1 || level === 2;
};

/**
 * Read-only 권한 확인
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {boolean}
 */
export const isReadOnly = (myAdmin) => {
  return getUserAdminLevel(myAdmin) === 3;
};

/**
 * 버튼이 허용되는지 확인 (Read-only는 refresh, search만 허용)
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @param {string} buttonType - 버튼 타입 ('refresh', 'search', 'other')
 * @returns {boolean}
 */
export const isButtonAllowed = (myAdmin, buttonType = 'other') => {
  const level = getUserAdminLevel(myAdmin);
  
  if (level === 1 || level === 2) {
    // Super Admin과 Operator는 모든 버튼 허용
    return true;
  }
  
  if (level === 3) {
    // Read-only는 refresh와 search만 허용
    return buttonType === 'refresh' || buttonType === 'search';
  }
  
  return false;
};

/**
 * Admin Control 페이지 접근 권한 확인
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {boolean}
 */
export const canAccessAdminControl = (myAdmin) => {
  return isSuperAdmin(myAdmin); // Super Admin만 접근 가능
};

/**
 * Admin Management 페이지 접근 권한 확인
 * @param {Object} myAdmin - 현재 사용자의 admin 정보
 * @returns {boolean}
 */
export const canAccessAdminManagement = (myAdmin) => {
  return isOperatorOrAbove(myAdmin); // Super Admin과 Operator 접근 가능
};
